import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { getClientWarehouseCode } from '../../../../api/shipping/get-client-warehouse-code'

/* Initial state of the slice */
const initialState = {
  currentStep: 1,
  totalSteps: 3,
  email: '',
  selectedRole: null,
  selectedOrganization: null,
  clientWarehouseCode: '',
  isInviteConfirmed: false,
  isFetchingClientWarehouseCode: false,
  fetchClientWarehouseCodeError: null,
}

/* Handler for making service call to fetch inventory items */
export const fetchClientWarehouseCode = createAsyncThunk(
  'inviteUser/fetchClientWarehouseCode',
  async (args, { rejectWithValue }) => {
    try {
      const response = await getClientWarehouseCode(args.clientCode)
      return response?.data.data?.warehouseCodes
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

const inviteUserSlice = createSlice({
  name: 'inviteUser',
  initialState,
  reducers: {
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload
    },
    resetCurrentStep: (state) => {
      state.currentStep = 1
    },
    setEmail: (state, action) => {
      state.email = action.payload
    },
    setSelectedRole: (state, action) => {
      state.selectedRole = action.payload
    },
    setSelectedOrganization: (state, action) => {
      state.selectedOrganization = action.payload
    },
    resetSelectedOrganization: (state) => {
      state.selectedOrganization = null
    },
    setClientWarehouseCode: (state, action) => {
      state.clientWarehouseCode = action.payload
    },
    resetClientWarehouseCode: (state) => {
      state.clientWarehouseCode = ''
    },
    setIsInviteConfirmed: (state) => {
      state.isInviteConfirmed = true
    },
    resetIsInviteConfirmed: (state) => {
      state.isInviteConfirmed = false
    },
    resetInviteUserSlice: () => {
      return initialState
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientWarehouseCode.pending, (state) => {
        state.isFetchingClientWarehouseCode = true
        state.clientWarehouseCode = ''
        state.fetchClientWarehouseCodeError = null
      })
      .addCase(fetchClientWarehouseCode.fulfilled, (state, action) => {
        state.isFetchingClientWarehouseCode = false
        state.clientWarehouseCode = action.payload
        state.fetchClientWarehouseCodeError = null
      })
      .addCase(fetchClientWarehouseCode.rejected, (state, action) => {
        state.isFetchingClientWarehouseCode = false
        state.fetchClientWarehouseCodeError = action.payload
      })
      /* Action which gets triggered
         when running persistor.purge() */
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export const {
  setCurrentStep,
  resetCurrentStep,
  setSelectedRole,
  setEmail,
  resetInviteUserSlice,
  setSelectedOrganization,
  resetSelectedOrganization,
  setClientWarehouseCode,
  resetClientWarehouseCode,
  setIsInviteConfirmed,
  resetIsInviteConfirmed,
} = inviteUserSlice.actions

export default inviteUserSlice.reducer
